<template>
  <v-container>
    <div>
      <v-card style="border-radius:12px">
        <v-toolbar flat color="white">
          <v-toolbar-title>Faturas</v-toolbar-title>
          <v-divider class="mx-4" inset vertical ></v-divider>
          <div class="flex-grow-1"></div>
          <!-- <v-btn rounded color="primary" dark class="mb-2" @click="dialog_supplier=true">Novo</v-btn> -->

        </v-toolbar>

        <v-card-text>
          <!-- Filtros Avançados -->
          <v-expansion-panels v-model="filtersPanel" class="mb-4">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-icon left>mdi-filter</v-icon>
                Filtros Avançados
                <template v-slot:actions>
                  <v-icon color="primary">mdi-chevron-down</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <!-- Busca por texto -->
                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="filters.search"
                      label="Buscar (cliente, comentário)"
                      prepend-icon="mdi-magnify"
                      clearable
                      @keyup.enter="applyFilters"
                    ></v-text-field>
                  </v-col>

                  <!-- Filtro por cliente -->
                  <v-col cols="12" md="6">
                    <v-autocomplete
                      v-model="filters.client_id"
                      :items="clientOptions"
                      item-text="name"
                      item-value="id"
                      label="Cliente"
                      prepend-icon="mdi-account"
                      clearable
                    ></v-autocomplete>
                  </v-col>

                  <!-- Filtros de data -->
                  <v-col cols="12" md="3">
                    <v-menu
                      ref="dueDateFromMenu"
                      v-model="dueDateFromMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="filters.due_date_from"
                          label="Vencimento de"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-on="on"
                          clearable
                          @click:clear="filters.due_date_from = null"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filters.due_date_from"
                        locale="pt-BR"
                        @input="dueDateFromMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-menu
                      ref="dueDateToMenu"
                      v-model="dueDateToMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="filters.due_date_to"
                          label="Vencimento até"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-on="on"
                          clearable
                          @click:clear="filters.due_date_to = null"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filters.due_date_to"
                        locale="pt-BR"
                        @input="dueDateToMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>

                  <!-- Filtros de valor -->
                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="filters.amount_from"
                      label="Valor mínimo"
                      prepend-icon="mdi-currency-brl"
                      type="number"
                      step="0.01"
                      clearable
                      @keyup.enter="applyFilters"
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field
                      v-model="filters.amount_to"
                      label="Valor máximo"
                      prepend-icon="mdi-currency-brl"
                      type="number"
                      step="0.01"
                      clearable
                      @keyup.enter="applyFilters"
                    ></v-text-field>
                  </v-col>

                  <!-- Ordenação -->
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="filters.sort_by"
                      :items="sortOptions"
                      label="Ordenar por"
                      prepend-icon="mdi-sort"
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-select
                      v-model="filters.sort_direction"
                      :items="sortDirectionOptions"
                      label="Direção"
                      prepend-icon="mdi-sort-alphabetical"
                    ></v-select>
                  </v-col>

                  <!-- Botões de ação -->
                  <v-col cols="12">
                    <v-btn color="primary" @click="applyFilters">
                      <v-icon left>mdi-filter</v-icon>
                      Aplicar Filtros
                    </v-btn>
                    <v-btn color="secondary" class="ml-2" @click="clearFilters">
                      <v-icon left>mdi-filter-remove</v-icon>
                      Limpar Filtros
                    </v-btn>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-row justify="center" v-if="loading">
            <v-col cols="12" align="center">
              <card-loading ></card-loading>
            </v-col>
          </v-row>

          <!-- Tabela com dados -->
          <div v-else>
                        <index-table
              :headers="headers"
              :items="all_bills_computed"
              :deletion_enabled="false"
              :disable_local_search="true"
              @editing="editing($event)"
              @deleting="deleting($event)"
              @copy-bill-url="copyBillUrl($event)"
            >
              <template v-slot:sumarized>
                <v-tooltip top v-for="(sf, idx) in stage_filters" :key="`sum_${idx}`">
                  <template v-slot:activator="{on}">
                    <v-chip v-on="on" pill class="ml-2">
                      <v-avatar left :class="status[sf].avatar_color">
                        <v-icon>{{status[sf].icon}}</v-icon>
                      </v-avatar>
                      {{bills_count[idx]}}
                    </v-chip>
                  </template>
                  {{status[sf].text}}
                </v-tooltip>
              </template>

              <template v-slot:filter>
                <v-dialog max-width="300px" scrollable>
                  <template v-slot:activator="{ on }">
                    <v-btn small text color="blue-grey darken-2" v-on="on">
                      <v-icon left>mdi-filter</v-icon>
                      Status
                    </v-btn>
                  </template>
                  <v-card style="border-radius:12px">
                    <v-card-title primary-title>
                      <div class="headline mb-0">Filtros de status</div>
                    </v-card-title>
                    <v-card-text>
                      <v-flex xs12 class="justify-center">
                        <v-subheader class="pl-2">Selecione os estados para exibição</v-subheader>
                        <v-btn text :disabled="stage_filters.length > 6" color="info" class="mt-1" @click="stage_filters = ['pending','overdue', 'paid', 'manual_payed', 'cancelled', 'error', 'processing']">Todos</v-btn>
                        <v-checkbox hide-details label="Pendentes" value="pending" v-model="stage_filters"></v-checkbox>
                        <v-checkbox hide-details label="Pagos" value="paid" v-model="stage_filters"></v-checkbox>
                        <v-checkbox hide-details label="Pagos Manualmente" value="manual_payed" v-model="stage_filters"></v-checkbox>
                        <v-checkbox hide-details label="Atrasados" value="overdue" v-model="stage_filters"></v-checkbox>
                        <v-checkbox hide-details label="Cancelados" value="cancelled" v-model="stage_filters"></v-checkbox>
                        <v-checkbox hide-details label="Com Erro" value="error" v-model="stage_filters"></v-checkbox>
                        <v-checkbox hide-details label="Processando" value="processing" v-model="stage_filters"></v-checkbox>
                      </v-flex>
                      <v-card-actions>
                        <v-btn color="primary" @click="applyFilters">
                          <v-icon left>mdi-filter</v-icon>
                          Aplicar
                        </v-btn>
                      </v-card-actions>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </template>
            </index-table>

            <!-- Paginação -->
            <v-row class="mt-4" justify="center" v-if="pagination.total_pages > 1">
              <v-col cols="12">
                <v-pagination
                  v-model="pagination.current_page"
                  :length="pagination.total_pages"
                  :total-visible="7"
                  @input="changePage"
                ></v-pagination>
              </v-col>
            </v-row>

            <!-- Informações de paginação -->
            <v-row class="mt-2" justify="center" v-if="pagination.total_count > 0">
              <v-col cols="12" class="text-center">
                <v-chip class="ma-1">
                  <v-icon left>mdi-information</v-icon>
                  Mostrando {{((pagination.current_page - 1) * pagination.per_page) + 1}} -
                  {{Math.min(pagination.current_page * pagination.per_page, pagination.total_count)}}
                  de {{pagination.total_count}} registros
                </v-chip>
                <v-select
                  v-model="pagination.per_page"
                  :items="perPageOptions"
                  label="Itens por página"
                  style="max-width: 120px; display: inline-block; margin-left: 16px;"
                  @input="changePerPage"
                ></v-select>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>

      <client-bill ref="client_bill"></client-bill>

      <dialog-loading v-if="loading" :loadText="loadingText"></dialog-loading>

    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '../api'
import indexTable from '../components/shared/IndexTable'

export default {
  name: 'Bills',
  components: {
    indexTable: ()=> import('@/components/shared/IndexTable'),
    ClientBill: () => import('@/components/financial/bills/ClientBill'),
  },
  data() {
    return {
      all_bills: null,
      loading: false,
      loadingText: null,
      stage_filters: ['pending', 'overdue', 'paid', 'manual_payed', 'cancelled', 'error', 'processing'],
      filtersPanel: 0,
      dueDateFromMenu: false,
      dueDateToMenu: false,

      // Filtros avançados
      filters: {
        search: '',
        client_id: null,
        status: null,
        due_date_from: null,
        due_date_to: null,
        amount_from: null,
        amount_to: null,
        sort_by: 'created_at',
        sort_direction: 'desc',
        page: 1,
        per_page: 20
      },

      // Paginação
      pagination: {
        current_page: 1,
        per_page: 20,
        total_count: 0,
        total_pages: 0,
        has_next_page: false,
        has_prev_page: false
      },

      // Opções para selects
      clientOptions: [],
      sortOptions: [
        { text: 'Data de Criação', value: 'created_at' },
        { text: 'Data de Vencimento', value: 'due_date' },
        { text: 'Valor', value: 'ammount' },
        { text: 'Status', value: 'status' },
        { text: 'Cliente', value: 'client_name' }
      ],
      sortDirectionOptions: [
        { text: 'Crescente', value: 'asc' },
        { text: 'Decrescente', value: 'desc' }
      ],
      perPageOptions: [10, 20, 50, 100],

      headers:[
        { text: 'Status', width: '10%' ,align: 'center', sortable: true, value: 'status'},
        { text: 'Cliente', width: '20%' ,align: 'left', sortable: true, value: 'client_name'},
        { text: 'Valor', width: '10%' ,align: 'center', sortable: true, value: 'ammount'},
        { text: 'Venc.', width: '10%' ,align: 'center', sortable: true, value: 'due_date'},
        { text: 'Criado em', width: '10%' ,align: 'center', sortable: true, value: 'created_at'},
        { text: 'Link Boleto', width: '10%' ,align: 'center', sortable: false, value: 'secure_url'},
        { text: 'Ação', width: '10%', value: 'action', sortable: false },
      ],
      status:{
        pending: {icon: "mdi-account-clock", text: "Pendente", avatar_color: "orange"},
        paid: {icon: "mdi-account-check", text: "Pago", avatar_color: "green"},
        cancelled: {icon: "mdi-cancel", text: "Cancelado", avatar_color: "grey"},
        overdue: {icon: "mdi-alarm-off", text: "Atrasado", avatar_color: "red"},
        manual_payed: {icon: "mdi-hand", text: "Pg. Manual", avatar_color: "blue"},
        error: {icon: "mdi-alert-circle", text: "Erro", avatar_color: "red darken-2"},
        processing: {icon: "mdi-cog", text: "Processando", avatar_color: "blue-grey"},
      },
    }
  },
  methods: {
    indexBill() {
      this.loading = true
      this.loadingText = 'Carregando faturas...'

      // Preparar parâmetros da API
      const apiParams = {
        ...this.filters,
        page: this.pagination.current_page,
        per_page: this.pagination.per_page
      }

      // Filtrar apenas status selecionados se não estiver usando filtro de status específico
      if (!apiParams.status && this.stage_filters.length < 7) {
        // Se não todos os status estão selecionados, aplicar filtro
        if (this.stage_filters.length === 1) {
          apiParams.status = this.stage_filters[0]
        }
      }

      Api.Bill.index(apiParams)
        .then(r => r.data)
        .then(response => {
          this.all_bills = response.data.map(o => o.attributes)

          // Atualizar informações de paginação
          if (response.meta) {
            this.pagination = {
              current_page: response.meta.current_page,
              per_page: response.meta.per_page,
              total_count: response.meta.total_count,
              total_pages: response.meta.total_pages,
              has_next_page: response.meta.has_next_page,
              has_prev_page: response.meta.has_prev_page
            }
          }

          this.loading = false
          this.loadingText = null
        })
        .catch(err => {
          this.loading = false
          this.loadingText = null
          console.error('Erro ao carregar faturas:', err)
          this.$swal({
            title: 'Erro',
            text: 'Erro ao carregar faturas. Tente novamente.',
            type: 'error'
          })
        })
    },

    applyFilters() {
      this.pagination.current_page = 1
      this.filters.page = 1
      this.indexBill()
    },

    clearFilters() {
      this.filters = {
        search: '',
        client_id: null,
        status: null,
        due_date_from: null,
        due_date_to: null,
        amount_from: null,
        amount_to: null,
        sort_by: 'created_at',
        sort_direction: 'desc',
        page: 1,
        per_page: this.pagination.per_page
      }
      this.stage_filters = ['pending', 'overdue', 'paid', 'manual_payed', 'cancelled', 'error', 'processing']
      this.applyFilters()
    },

    changePage(page) {
      this.pagination.current_page = page
      this.filters.page = page
      this.indexBill()
    },

    changePerPage(perPage) {
      this.pagination.per_page = perPage
      this.pagination.current_page = 1
      this.filters.per_page = perPage
      this.filters.page = 1
      this.indexBill()
    },

    loadClients() {
      // Carregar lista de clientes para o autocomplete
      Api.Client.index()
        .then(r => r.data)
        .then(clients => {
          this.clientOptions = clients.data ? clients.data.map(c => ({
            id: c.attributes.id,
            name: c.attributes.name
          })) : []
        })
        .catch(err => {
          console.error('Erro ao carregar clientes:', err)
        })
    },

    editing(id){
      this.$refs.client_bill.editing(id)
    },

    openBillFromUrl() {
      // Verificar se há um parâmetro bill_id na URL
      const billId = this.$route.query.bill_id;
      if (billId) {
        this.editing(billId);
      }
    },

    generateBillUrl(billId) {
      // Gerar URL direta para uma fatura específica
      const baseUrl = window.location.origin;
      const currentPath = this.$route.path;
      return `${baseUrl}${currentPath}?bill_id=${billId}`;
    },

    copyBillUrl(billId) {
      // Copiar URL da fatura para a área de transferência
      const url = this.generateBillUrl(billId);
      navigator.clipboard.writeText(url).then(() => {
        this.$swal({
          title: 'Sucesso!',
          text: 'URL copiada para a área de transferência',
          type: 'success',
          timer: 2000
        });
      }).catch(() => {
        // Fallback para navegadores mais antigos
        const textArea = document.createElement('textarea');
        textArea.value = url;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        this.$swal({
          title: 'Sucesso!',
          text: 'URL copiada para a área de transferência',
          type: 'success',
          timer: 2000
        });
      });
    },

    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.indexBill()
    this.loadClients()
    this.openBillFromUrl()
  },
  computed: {
    all_bills_computed() {
      if (this.all_bills){
        // Se estivermos usando filtros de status múltiplos, filtrar localmente
        if (this.stage_filters.length < 7 && this.stage_filters.length > 1) {
          return this.all_bills.filter(o => this.stage_filters.includes(o.status))
        }
        return this.all_bills
      }
      return []
    },

    bills_count(){
      if (this.all_bills){
        let result = []
        for (let index = 0; index < this.stage_filters.length; index++) {
          result.push(this.all_bills.filter(o => this.stage_filters[index] == (o.status)).length)
        }
        return result
      }
      return []
    },
    ...mapState({
      updateBillWasGood: state => state.Bill.updateBillWasGood,
      updateBillMessage: state => state.Bill.updateBillMessage,
    })
  },
  watch: {
    '$route.query.bill_id'(newBillId, oldBillId) {
      // Quando o bill_id muda na URL, abrir a fatura correspondente
      if (newBillId && newBillId !== oldBillId) {
        this.editing(newBillId);
      }
    },
    updateBillWasGood(nv,ov) {
      if (nv){
        this.indexBill()
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>